import { ApiResult, request, safeRequest } from '@synergy/api';
import { Canceler } from 'axios';

import { CustomerDocument } from '../models/customer-detail-document';
import { DocumentPatchRequest } from './models/document-patch.request';

export class CustomerDocumentsApi {
    constructor(protected baseUrl: string) {}

    public getDocuments(customerId: number): Promise<ApiResult<CustomerDocument[]>> {
        return safeRequest(
            () => request.get<{ documents: CustomerDocument[] }>(`${this.baseUrl}/customers/${customerId}/documents`),
            response => response.data.documents
        );
    }

    public addDocument(
        customerId: number,
        file: File,
        cancelFunction?: (canceler: Canceler) => void,
        progressCallback?: (progress: ProgressEvent) => void
    ): Promise<ApiResult<CustomerDocument>> {
        return safeRequest(
            () => {
                const data = new FormData();
                data.append('file', file, file.name);

                const config = {
                    headers: { 'content-type': 'multipart/form-data' },
                    onUploadProgress: progressCallback,
                    cancelToken: cancelFunction && new request.CancelToken(cancelFunction),
                };

                return request.post(`${this.baseUrl}/customers/${customerId}/documents/upload`, data, config);
            },
            response => response.data
        );
    }

    public updateDocument(customerId: number, patch: DocumentPatchRequest): Promise<ApiResult<CustomerDocument>> {
        return safeRequest(
            () =>
                request.patch(`${this.baseUrl}/customers/${customerId}/documents/${patch.id}`, {
                    title: patch.title,
                }),
            response => response.data
        );
    }

    public deleteDocument(customerId: number, documentId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/customers/${customerId}/documents/${documentId}`),
            response => response.data
        );
    }
}
